import React, { PureComponent } from "react";
import styled from 'styled-components';

import SearchIcon from '../../../containers/assets/icon-search.svg';

const SearchWrapper = styled.div`
  padding: 8px 16px;
`;

const SearchInputWrapper = styled.div`
  position: relative;
  width: 240px;
`;

const SearchInputIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 18px;
  width: 12px;
  height: 12px;
  display: flex;
`;

const SearchInput = styled.input`
  padding: 7px 12px 7px 40px;
  border: 1px solid #CED1D6;
  border-radius: 4px;
  width: 100%;
`;

class TeamsRolesSearch extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      typing: false,
      typingTimeout: 0
    };
  }

  handleInputChange = (event) => {
    const { handleQueryChange } = this.props;

    const { typingTimeout } = this.state;

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const newQuery = event.target.value;

    this.setState({
      query: newQuery,
      typing: false,
      typingTimeout: setTimeout(function () {
        handleQueryChange(newQuery);
      }, 2000)
    });
  };

  render() {
    const { query } = this.state;
    return (
      <SearchWrapper>
        <SearchInputWrapper>
          <SearchInputIcon>
            <img src={SearchIcon} alt="Search" />
          </SearchInputIcon>
          <SearchInput
            type="text"
            value={query}
            placeholder="Search by name or email"
            onChange={this.handleInputChange}
          />
        </SearchInputWrapper>
      </SearchWrapper>
    );
  }
}

export default TeamsRolesSearch;



// WEBPACK FOOTER //
// ./src/instructor/components/teams-roles/search.js